import { render, staticRenderFns } from "./developing.vue?vue&type=template&id=bad4fe52&scoped=true"
import script from "./developing.vue?vue&type=script&lang=js"
export * from "./developing.vue?vue&type=script&lang=js"
import style0 from "./developing.vue?vue&type=style&index=0&id=bad4fe52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad4fe52",
  null
  
)

export default component.exports